import React, { useEffect, useState } from "react";
import "./patientNationalId.css";
import { useTranslation } from "react-i18next";
import Widgets from "../../widgets";
import { uploadMedia, getNatCategory } from "../../modules/patientProfile/patientProfileThunk";
import { resetRejectHnReq, resetUploadMedia, resetIdList } from "../../modules/patientProfile/patientProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import ToastPopup from "../../widgets/Toast/toastPopup";
import useValidation from "../../utils/validators";

const PatientNationalId = ({ userId, setSelectedView, setPage, userNationalId, setRequestData, hasHn, countryId }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { rejectHnReqErr, rejectHnReq, uploadMediaSuccess, uploadMediaErr, idList, idListErr } = useSelector((state) => state.patientProfile);
  const { validateNationalIdAndPassport } = useValidation();
  const [frontNationalIdImage, setFrontNationalIdImage] = useState("");
  const [backNationalIdImage, setBackNationalIdImage] = useState("");
  const [action, setAction] = useState("");
  const [showReject, setShowReject] = useState(false);
  const [idType, setIdType] = useState("");
  const [idArray, setIdArray] = useState([]);

  // useEffect(() => {
  //   const updateImageUrl = (url) => {
  //     if (url) {
  //       return url.includes(" ") ? url.replace(/ /g, "%20") : url;
  //     }
  //     return url;
  //   };
  //   setFrontNationalIdImage((prev) => updateImageUrl(prev));
  //   setBackNationalIdImage((prev) => updateImageUrl(prev));
  // }, [frontNationalIdImage, backNationalIdImage]);

  useEffect(() => {
    if (rejectHnReqErr) {
      ToastPopup(rejectHnReqErr);
    }
    if (rejectHnReq && rejectHnReq.data.rejected) {
      ToastPopup.success(t("reqRejected"));
      setSelectedView("patientProfileList");
    }
    dispatch(resetRejectHnReq());
  }, [rejectHnReqErr, rejectHnReq]);

  useEffect(() => {
    if (uploadMediaErr) {
      ToastPopup.error(uploadMediaErr);
    }
    if (uploadMediaSuccess && uploadMediaSuccess.status === "success") {
      const url = uploadMediaSuccess.data.urls[0];
      const finalUrl = url.replace(/ /g, "%20");
      if (action === "frontNatId") {
        setRequestData((prevState) => ({
          ...prevState,
          nationalId: {
            ...prevState.nationalId,
            images: {
              ...prevState.nationalId.images,
              front: finalUrl,
            },
          },
        }));
      }
      if (action === "backNatId") {
        setRequestData((prevState) => ({
          ...prevState,
          nationalId: {
            ...prevState.nationalId,
            images: {
              ...prevState.nationalId.images,
              back: finalUrl,
            },
          },
        }));
      }
    }
    dispatch(resetUploadMedia());
  }, [uploadMediaErr, uploadMediaSuccess]);

  useEffect(() => {
    const categoryId = userNationalId?.category;
    const selectedId = idArray.find((item) => item.category === categoryId);
    if (selectedId) {
      setIdType(selectedId.title);
    }
  }, [userNationalId]);

  useEffect(() => {
    dispatch(getNatCategory(countryId));
  }, [countryId, i18n.language]);

  useEffect(() => {
    if (idListErr) {
      ToastPopup.error(idListErr);
    }
    if (idList && idList.status === "success") {
      const categoriesWithCountry = idList.data.categories.map((category) => ({
        title: category.title,
        category: category._id,
      })) .sort((a, b) => a.title.localeCompare(b.title));

      const categoryId = userNationalId?.category;
      const selectedId = categoriesWithCountry.find((item) => item.category === categoryId);
      if (selectedId) {
        setIdType(selectedId.title);
      }
      setIdArray(categoriesWithCountry);
    }
    dispatch(resetIdList());
  }, [idList, idListErr]);

  useEffect(() => {
    if (userNationalId === null && idArray && idArray.length > 0) {
      setRequestData((prevState) => ({
        ...prevState,
        nationalId: {
          ...prevState.nationalId,
          category: idArray[0].category,
        },
      }));
    }
  }, [userNationalId, idArray]);

  const handleImageUpload =
    (idType) =>
    ({ files }) => {
      dispatch(uploadMedia({ files }));
      setAction(idType);
    };

  const handleReject = () => {
    setShowReject(true);
  };
  const handleCancelReject = () => {
    setShowReject(false);
  };

  const handleConfirmReject = () => {
    setShowReject(false);
  };

  const handleNationalIdChange = (e) => {
    setRequestData((prevState) => ({
      ...prevState,
      nationalId: {
        ...prevState.nationalId,
        number: e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 20),
      },
    }));
  };

  const setNextPage = () => {
    const isValid = validateNationalIdAndPassport({
      nationalIdNumber: userNationalId?.number,
      frontNationalIdImage: userNationalId?.images?.front,
      backNationalIdImage: userNationalId?.images?.back,
      idType: userNationalId?.category,
    });
    if (isValid) {
      setPage(4);
    }
  };

  return (
    <div className="pdl-info verify">
      <p className="pdl-title">{t("nationalIdInfo")}</p>
      <>
        <div className="piv-id nat-id piv-id-number">
          <div>
            <p className="piv-subtitle">
              {t("idType")} <span className="asterik">*</span>
            </p>
            <Widgets.SelectDropdown
              options={idArray.map((item) => item.title)}
              selectedValue={idType || (idArray && idArray.length > 0 ? idArray[0].title : "")}
              onChange={(selectedTitle) => {
                const selectedItem = idArray.find((item) => item.title === selectedTitle);
                setRequestData((prevState) => ({
                  ...prevState,
                  nationalId: {
                    ...prevState.nationalId,
                    category: selectedItem.category,
                  },
                }));
              }}
              placeholder="selType"
              big
              disabled={userNationalId?._id}
            />
          </div>
          <div>
            <p className="piv-subtitle">
              {t("idNumber")} <span className="asterik">*</span>
            </p>
            <input className="piv-number" value={userNationalId?.number} placeholder={t("enterIdNum")} onChange={handleNationalIdChange} disabled={userNationalId?._id} />
          </div>
        </div>
        <div className="id-select-card">
          <Widgets.SelectCard
            image={userNationalId?.images?.front}
            title="frontNatioalId"
            idType={"frontNatId"}
            front
            setImage={(url) =>
              setRequestData((prevState) => ({
                ...prevState,
                nationalId: {
                  ...prevState.nationalId,
                  images: {
                    ...prevState.nationalId.images,
                    front: url,
                  },
                },
              }))
            }
            onImageUpload={handleImageUpload("frontNatId")}
            disabled={!userNationalId?.number || userNationalId?._id}
          />
          <Widgets.SelectCard
            image={userNationalId?.images?.back}
            title="backNatioalId"
            idType={"backNatId"}
            setImage={(url) =>
              setRequestData((prevState) => ({
                ...prevState,
                nationalId: {
                  ...prevState.nationalId,
                  images: {
                    ...prevState.nationalId.images,
                    back: url,
                  },
                },
              }))
            }
            onImageUpload={handleImageUpload("backNatId")}
            disabled={!userNationalId?.number || userNationalId?._id}
          />
        </div>
      </>
      <>
        <div className="save-speciality info">
          <>
            {hasHn && (
              <div className="speciality-cancel reject" onClick={handleReject}>
                {t("reject")}
              </div>
            )}
            <div className="speciality-save" onClick={() => setNextPage()}>
              {t("next")}
            </div>
          </>
        </div>
      </>
      <Widgets.Reject showModal={showReject} handleCancel={handleCancelReject} handleConfirm={handleConfirmReject} reason="rejPhotoId" userId={userId} />
    </div>
  );
};

export default PatientNationalId;
